/**
 * The default locale language code across Appsemble Studio and apps.
 */
export const defaultLocale = 'en';
